import { StatsTablePagination } from './table-pagination';

export { StatsTablePagination };
